import React, { useState, useLayoutEffect, useCallback } from 'react';
import Headroom from 'react-headroom';
import { AppBar, Toolbar } from '@material-ui/core';
import { useStyles } from "./styles.js";
export const Header = ({
  children,
  elevation,
  height,
  background,
  disableGutters
}) => {
  const [collapsed, setCollapsed] = useState(true);
  const classes = useStyles({
    collapsed,
    height,
    background
  });
  const handleScroll = useCallback(() => {
    if (window.scrollY > 64) {
      setCollapsed(false);
    } else {
      setCollapsed(true);
    }
  }, []);
  useLayoutEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);
  return /*#__PURE__*/React.createElement(Headroom, null, /*#__PURE__*/React.createElement(AppBar, {
    position: "fixed",
    elevation: elevation,
    className: classes.appBar
  }, /*#__PURE__*/React.createElement(Toolbar, {
    className: classes.toolbar,
    disableGutters: disableGutters
  }, children)));
};
Header.defaultProps = {
  elevation: 0,
  height: 64,
  disableGutters: false
};
Header.displayName = 'Header';
export default Header;